import { render, staticRenderFns } from "./PopupWindow.vue?vue&type=template&id=3575d247&scoped=true&"
import script from "./PopupWindow.vue?vue&type=script&lang=js&"
export * from "./PopupWindow.vue?vue&type=script&lang=js&"
import style0 from "./PopupWindow.vue?vue&type=style&index=0&id=3575d247&prod&scoped=true&lang=scss&"
import style1 from "./PopupWindow.vue?vue&type=style&index=1&id=3575d247&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3575d247",
  null
  
)

export default component.exports